import React from 'react';

const LABELS = {
  done: 'Done',
  running: 'Running',
  waiting: 'Waiting for you',
  failed: 'Failed',
  notrun: 'Not run',
};
const RING = { done: '#2f8a4a', failed: '#C2412D', notrun: '#B9BCC8' };

export default function StatusMark({ status, size = 14 }) {
  const key = LABELS[status] ? status : 'notrun';
  let shape;
  if (key === 'running') {
    shape = <rect x="3" y="3" width="10" height="10" fill="#3c6a9a" />;
  } else if (key === 'waiting') {
    shape = (
      <>
        <rect x="3.5" y="2.5" width="3" height="11" fill="#1B1F3B" />
        <rect x="9.5" y="2.5" width="3" height="11" fill="#1B1F3B" />
      </>
    );
  } else {
    shape = <circle cx="8" cy="8" r="5.5" fill="none" stroke={RING[key]} strokeWidth="2" />;
  }
  return (
    <span role="img" aria-label={LABELS[key]} className="inline-flex shrink-0" style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true">{shape}</svg>
    </span>
  );
}
